// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3YB1S","location":"Header_location__dhtF4"};